import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler, Keyboard
} from "react-native";
import HMActionBar from "../../../../../customviews/HMActionBar";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import {moderateScale} from "../../../../../tools/Scaling";
import Colors from "../../../../../tools/Colors";
import HMTextView from "../../../../../customviews/HMTextView";
//import MapboxGL from "@mapbox/react-native-mapbox-gl";
import HMListItem2 from "../../../../../customviews/HMListItem2";
import i18n from '../../../../../I18n/i18n.js';
import {Tools} from "../../../../../tools/Tools";
import PathFile from "../../../../../assets/PathFile";
import {typeExport} from "../../../../../redux/store/type";
import HMDetailsMap from "../../../../../customviews/HMDetailsMap";

import HMVideo from "../../../../../customviews/video/HMVideo";
import HMIcon from "../../../../../customviews/HMIcon";
import HMMap1 from "../../../../../customviews/map/HMMap";

import HMSwiper from "../../../../../customviews/swiper/HMSwiper";
import HMModal from "../../../../../customviews/modal/HMModal";
import HMImageView from "../../../../../customviews/HMImageView";
import HMFilesTest from "../../../../../customviews/file/HMFilesTest";
import HMTextInput from "../../../../../customviews/HMTextInput";
import HMListCheckBox from "../../../../../customviews/HMListCheckBox";
import HMSelectInput from "../../../../../customviews/HMSelectInput";
import axios from "axios";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import store from "../../../../../redux/store";
import * as NavigationService from "../../../../../redux/NavigationService";


// import {VideoPlayer} from "react-native-video-processing";
// import Video from "react-native-af-video-player";
//import Orientation from "react-native-orientation";
//import Sound from "react-native-sound";
var sound = null
//Sound.setCategory('Playback');
let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;


const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}


export default class ExpertRegistrationMahaleMaScreen extends Component {
    static navigationOptions = ({navigation}) => {
        const {state} = navigation
        // Setup the header and tabBarVisible status
        const header = state.params && (state.params.fullscreen ? undefined : null)
        const tabBarVisible = state.params ? state.params.fullscreen : true
        return {
            // For stack navigators, you can hide the header bar like so
            header,
            // For the tab navigators, you can hide the tab bar like so
            tabBarVisible,
        }
    }

    constructor(props) {
        super(props);
        container = this;
        //   let _item = JSON.parse(props.route.params.itemExtra);
        let _item = this.props.route.params.itemExtra;
        let _edit = this.props.route.params.edit;

        let {files} = _item;

        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;
        }

        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,

            modalHeight: 0,
            isFull: false,


            listUser: [],
            listVideo: [],
            listImage: [],
            listVoice: [],
            listOthers: [],
            slider1ActiveSlide: 0,


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
            playSeconds: 0.0,
            playState: 'playing',
            indexSelectCheckBoxType: 2,
            TextInputExpertDescription: _edit?.description,
            Roll: _edit ? {
                    ..._edit,
                    index: 0,
                } :
                null,
            SelectRollValue: _edit?.id,


        };

        if (files)
            for (let i = 0; i < files.length; i++) {
                let f = String(files[i].type);

                if (f.search('audio/') >= 0)
                    this.state.listVoice.push(files[i])

                else if (f.search('image/') >= 0)
                    this.state.listImage.push(files[i])

                else if (f.search('video/') >= 0)
                    this.state.listVideo.push(files[i])
                else {

                    this.state.listOthers.push(files[i])

                }

            }
        this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props

    }

    async componentDidMount() {
        if (this.props.route.params.type == "add")
            this.getListExpert();

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })
        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        })


    }


    componentWillMount() {
        this.props.callserviceActionRefresh();
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

        if (sound) {
            sound.release();
            sound = null;
        }
        if (this.timeout) {
            clearInterval(this.timeout);
        }

    }

    componentWillReceiveProps(props) {
    }

    getListExpert() {
        this.setState({
            isLoadingListUser: true
        })
        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT,
            }
        };
        const formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetExperts");
        formData.append('token_mahale', this.props.DataSplashScreen.tokenMahaleh);
        formData.append('_session', this.props.DataSplashScreen.token);

        axios.post(typeExport._baseUrlSainaShahrdar, formData, config)
            .then(async response => {
                if (response.data.success) {
                    this.setState({
                        listUser: response.data.result
                    })

                    global._listExpert = response.data.result;
                }
                else {

                }
                this.setState({
                    isLoadingListUser: false
                })
                // func ? func(response) : null;
            }).catch((e) => {
            //func ? func(null) : null;
            this.setState({
                isLoadingListUser: false
            })
            console.log(e)
        })

    }

    getData(type) {
        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': type ? "" : typeExport._GetCsStatus,
            'token_mahale': this.props.DataSplashScreen.tokenMahaleh,
            "customValue": this.state.stateItemExtra.status,
            "state_params": this.props.route.params,
            "lang": i18n.locale,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, type ? type : typeExport.TypeGetDetailsOperatorApplyScreen, typeExport._GET, store.getState().reducerSplashGetAllData.token)
    }


    setDataSendAnswer(type) {
        let _item = this.props.route.params.itemExtra;
        //record:
        // comment:
        // operator:

        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': "SaveExpertForm",
            'record': _item.id,
            'comment': this.state.TextInputresultExpert,
            'resultToMeeting': this.state.TextInputResultToMeeting,
            'token_mahale': this.props.DataSplashScreen.tokenMahaleh,
            "lang": i18n.locale,

            "needToMeeting": this.state.indexSelectCheckBoxType,

            "arrImage": this.state.arrImage,
            "video": this.state.pathVideo,
            "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
            "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
            "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeSetExpertRegistrationMahaleMaScreen, typeExport._GET, store.getState().reducerSplashGetAllData.token, null)
    }

    setData(type) {
        let _item = this.props.route.params.itemExtra;
        //record:
        // comment:
        // operator:

        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': "SaveExpertRefrence",
            'record': _item.id,
            'comment': this.state.TextInputExpertDescription,
            'token_mahale': this.props.DataSplashScreen.tokenMahaleh,
            "lang": i18n.locale,
            'operator': this.state.SelectRollValue,

            "arrImage": this.state.arrImage,
            "video": this.state.pathVideo,
            "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
            "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
            "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeSetExpertRegistrationMahaleMaScreen, typeExport._GET, store.getState().reducerSplashGetAllData.token, this.setListMessageExpert)

    }

    setListMessageExpert(data) {
        let _item = container.props.route.params.itemExtra;

        if (data && data.result) {

            _item["listMessageExpert"] = data.result.length > 0 ? data.result : [data.result];
            //  _item["listMessageExpert"] = [data];

        }
        else {
            _item["listMessageExpert"] = [{
                value: 1,
                label: this.state.Roll?.label,
                id: 1,
                name: this.state.Roll?.label,
                date: new Date().getTime(),
                description: container.state.TextInputExpertDescription,


            }];
        }


    }

////////////////audio///////////////

    async _pause() {
        sound.pause();

    }

    async _play(audioPath) {


        sound = await
            new Sound(audioPath, '', (error) => {
                if (error) {
                    console.log('failed to load the sound', error);
                    return;
                }
                sound.play((success) => {
                    if (success) {
                        this.setState(
                            {
                                playState: 'playing'
                            },
                            () => {
                                // this._pause()

                            }
                        )
                    } else {
                        console.log('playback failed due to audio decoding errors');
                    }
                });
                if (this.timeout) {
                    clearInterval(this.timeout);
                }
                this.timeout = setInterval(() => {
                    if (sound && sound.isLoaded() && (this.state.playState == 'playing' || this.state.playState == 'paused')) {
                        sound.getCurrentTime((seconds, isPlaying) => {
                            this.setState({playSeconds: seconds});
                        })
                    }
                }, 100);
            });


    }

    switchIcon() {
//playing, paused ,record , stop
        switch (this.state.playState) {
            case 'playing':


                return PathFile.image.img_play

            case 'paused':

                return PathFile.image.img_pause

            default :

        }
    }

    switchOnPress(audioPath) {
        switch (this.state.playState) {


            case 'playing':

                this.setState(
                    {
                        playState: 'paused'
                    },
                    () => {
                        this._play(audioPath)
                    }
                )
                break;

            case 'paused':
                this.setState(
                    {
                        playState: 'playing'
                    },
                    () => {
                        this._pause()

                    }
                )
                break;


            default :

        }


    }

    /////////////////////////
    hiddenModal() {
        if (sound) {
            this.setState({
                    playState: 'playing'
                },
                () => {

                })

            this._pause()

        }
        this.setState({
                visibleModal: ''
            },
            () => {
                // Orientation.unlockAllOrientations();
                // Orientation.lockToPortrait();
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }

    onFullScreen = (value) => {
        // Set the params to pass in fullscreen status to navigationOptions
        this.props.navigation.setParams({
            fullscreen: !value
        })
        if (value) {
            //Orientation.lockToLandscape();
        } else {
            //Orientation.unlockAllOrientations();
            //Orientation.lockToPortrait();
        }
        this.setState({
            isFull: value
        })
    }

    getZoomPanOptions() {
        const animate = true
        const noMoveStart = true
        const easeLinearity = true
        const duration = 100
        return {
            animate,
            duration,
            easeLinearity,
            noMoveStart,
        }
    }

    async onFlyToPress(long, lat) {

        //await this.map.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18)

        }
        else {
            const camera = await this.map.mapRef.current.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            // this.onFlyToComplete();
        }

    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [Constants.Longitude, Constants.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            // mode: MapboxGL.CameraModes.Flight,
        });

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }


    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };

    render() {
        let {slider1ActiveSlide} = this.state

        const placeholder = 'https://your-url.com/placeholder.png'
        let _params = this.props.route.params;
        //  let _item = JSON.parse(_params.itemExtra);
        let _item = this.props.route.params.itemExtra;
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, color} = _item;
        //let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, color} = this.props.route.params.item;

        let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type.search('audio/') >= 0)?.file));
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type.search('video/') >= 0)?.file));
        //
        // checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type.search('audio/') >= 0)) && (files.find(k => k.type.search('audio/') >= 0)).file);
        // checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type.search('video/') >= 0)) && (files.find(k => k.type.search('video/') >= 0)).file);
        // let listUser = [{label: "حسن احمدی", value: "1"}, {label: "فیروزکریمی", value: "2"}];
        let {listUser} = this.state;
        // listUser = [{label: "حسن احمدی", value: "1"}, {label: "فیروزکریمی", value: "2"}];
        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar menu={this.props.route.params.type !== typeExport._Shahrdar}
                                     props={this.props}
                                     statusBarTransparent
                            //   text={i18n.t('Privatizations.title')}
                                     text={"فرم کارشناسی"}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />

                        <ScrollView
                            // ref={scroll => this._onRef('_scroll', scroll)}
                            style={{
                                //  backgroundColor: "white"
                            }}>
                            {
                                _params.type == "add" ?
                                    <View
                                        style={{
                                            flex: 1
                                        }}>
                                        <View style={{width: "100%", alignItems: "center"}}>
                                            <View style={{
                                                borderRadius: moderateScale(8),
                                                borderColor: Colors.blackLight,
                                                borderWidth: moderateScale(1),
                                                width: "98%",
                                                alignSelf: "center",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(10),
                                                marginVertical: moderateScale(10),
                                                //  height: moderateScale(300)
                                            }}>
                                                <HMSelectInput DropdownModal
                                                    // title={"ارجاع به : "}

                                                               onValueChange={(value, itemSelctInput) => {

                                                                   let idx = listUser.findIndex(obj => obj.value == value);
                                                                   let res = null;
                                                                   if (idx !== -1) {
                                                                       res = listUser[idx]
                                                                   }

                                                                   this.setState({
                                                                           SelectRollValue: value,
                                                                           Roll: {
                                                                               ...res,
                                                                               index: idx
                                                                           } ? res : {
                                                                               label: i18n.t('constant.SelectItem'),
                                                                               value: idx,
                                                                               index: idx
                                                                           }
                                                                       },
                                                                       () => {
                                                                       }
                                                                   )
                                                               }}
                                                    // error={this.state.errorSelectInput}
                                                    //
                                                    // //  requestServerRetry={container.getServerTypeDocuments}
                                                    // requestServer={() => {
                                                    // }}
                                                               value={this.state.SelectRollValue ? this.state.Roll.label : i18n.t('constant.SelectItem')}
                                                               index={this.state.Roll ? this.state.Roll.index : -1}
                                                               itemSelectInput={this.state.Roll}
                                                               options={listUser?.length>0 ? listUser : (global._listExpert ? global._listExpert : [])}

                                                               styleRoot={{
                                                                   width: '100%'
                                                               }}
                                                />

                                            </View>

                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    backgroundColor: Colors.white,
                                                    paddingHorizontal: moderateScale(6)
                                                }}>


                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDarkText,
                                                            }}
                                                            text={"انتخاب کارشناسی"}
                                                    //   text={"98/03/21"}
                                                />

                                            </View>

                                        </View>
                                        <View style={{width: "100%", alignItems: "center"}}>
                                            <View
                                                style={{
                                                    borderRadius: moderateScale(8),
                                                    borderColor: Colors.blackLight,
                                                    borderWidth: moderateScale(1),
                                                    width: "98%",
                                                    alignSelf: "center",
                                                    backgroundColor: Colors.white,
                                                    padding: moderateScale(10),
                                                    marginVertical: moderateScale(10),
                                                    //  height: moderateScale(300)
                                                }}>
                                                <HMTextInput
                                                    _ref={(ref) => this.valueRefTextInputExpertDescription = ref}
                                                    // style={{height: moderateScale(40),
                                                    //     borderColor: 'gray',
                                                    //     borderWidth: moderateScale(1),
                                                    //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                    //
                                                    // }}
                                                    //  title={ "نام کاربری"}
                                                    placeholder={"... دستور کارشناسی "}
                                                    // title={'constant.phoneNumber'}
                                                    // placeholder={'constant.PH_phoneNumber'}
                                                    // lang
                                                    styleTitle={{color: Colors.blackLight}}
                                                    onChangeText={text => this.onChangeText("TextInputExpertDescription", text)}
                                                    onSubmitEditing={() => {
                                                        //  this.checkMobile(this.state.mobile)
                                                    }}
                                                    // onPressClear={() => this.onChangeText("value", null)}
                                                    onPressClear={() => {
                                                        this.onChangeText("TextInputExpertDescription", null)
                                                        this.valueRefTextInputExpertDescription.clear()
                                                    }}
                                                    value={this.state.TextInputExpertDescription}
                                                    // keyboardType="numeric"
                                                    styleRoot={{
                                                        borderRadius: moderateScale(8),
                                                        borderColor: Colors.blackLight,
                                                        borderWidth: moderateScale(1),
                                                    }}
                                                />
                                                {/*   <HMFilesTest
                                                    stateParent={this.state}
                                                    _setStateData={this._setStateData}
                                                    // _setStateDataParent={container.props._setStateData}
                                                    SizeBox={3}
                                                    styleRoot2={{
                                                        flexDirection: 'row',
                                                        flexWrap: 'wrap',
                                                        width: "100%",

                                                        // flexGrow: 1,
                                                        //  backgroundColor: "#ee04d0",
                                                        alignItems: "flex-start"

                                                    }}
                                                    //clearState={this.clearState}

                                                />*/}
                                            </View>

                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    backgroundColor: Colors.white,
                                                    paddingHorizontal: moderateScale(6)
                                                }}>
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDarkText,
                                                            }}
                                                            text={"متن دستور به کارشناس یا کارشناسان"}
                                                    //   text={"98/03/21"}
                                                />

                                            </View>

                                        </View>
                                        <View
                                            style={{
                                                width: '100%',
                                                height: moderateScale(42),
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: moderateScale(10),
                                                marginBottom: moderateScale(3),
                                            }}
                                        >
                                            <TouchableOpacity
                                                onPress={() => {
                                                    // _item["listMessageExpert"] = [{
                                                    //     id: 1,
                                                    //     name: "احمد خلیلی",
                                                    //     date: "1401/4/1 9:23",
                                                    //     description: "باسلام بودجه مورد نیاز برآورده گردد",
                                                    //     files: [{
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2020/December/week3/484887_1608533505888.aac",
                                                    //         type: "audio/aac"
                                                    //     }, {
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564508_1620808463020.mp4",
                                                    //         type: "video/mp4"
                                                    //     }, {
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564514_1620808463020.jpg",
                                                    //         type: "image/jpeg"
                                                    //     }],
                                                    // }];
                                                    // _item["listMessageExpert"] = [{
                                                    //     id: this.state.SelectRollValue,
                                                    //     name: this.state.Roll?.label,
                                                    //     date: moment(new Date()).format("jYYYY/jMM/jDD hh:mm"),
                                                    //     description: this.state.TextInputExpertDescription,
                                                    //
                                                    //
                                                    //     value: this.state.SelectRollValue,
                                                    //     label: this.state.Roll?.label,
                                                    //
                                                    //
                                                    // }];
                                                    // NavigationService.Pop();

                                                    // [{
                                                    //     id: 1,
                                                    //     name: "علی ظفریان",
                                                    //     date: "1401/4/1 9:23",
                                                    //     description: "باسلام بودجه مورد نیاز برآورده گردد",
                                                    //     files: [{
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2020/December/week3/484887_1608533505888.aac",
                                                    //         type: "audio/aac"
                                                    //     }, {
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564508_1620808463020.mp4",
                                                    //         type: "video/mp4"
                                                    //     }, {
                                                    //         file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564514_1620808463020.jpg",
                                                    //         type: "image/jpeg"
                                                    //     }],
                                                    // }]
                                                    // this.goBack();

                                                    this.setData();
                                                }}
                                                style={{
                                                    flex: 1,
                                                    height: moderateScale(42),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderRadius: moderateScale(6)

                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={"ثبت کارشناس"} type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(13),
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                    </View>
                                    :
                                    <View style={{flex: 1}}>
                                        <View style={{
                                            borderRadius: moderateScale(8),
                                            borderColor: Colors.blackLight,
                                            borderWidth: moderateScale(1),
                                            width: "98%",
                                            alignSelf: "center",
                                            backgroundColor: Colors.white,
                                            padding: moderateScale(10),
                                            marginVertical: moderateScale(10),


                                        }}>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    flexWrap: 'wrap',
                                                    flex: 1,
                                                    flexGrow: 1,
                                                    //   lineHeight: moderateScale(10),
                                                    justifyContent: "space-between",
                                                }}>
                                                <View
                                                    style={{flexDirection: "row", marginHorizontal: moderateScale(2)}}>
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.getConstants().isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.blackLight,
                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={"ارجاع دهنده :"}
                                                        //   text={"98/03/21"}
                                                    />
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.getConstants().isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDark,
                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={_item.refrenceExpert}
                                                        //   text={"98/03/21"}
                                                    />
                                                </View>
                                                <View style={{
                                                    flexDirection: "row",
                                                    marginHorizontal: moderateScale(2)
                                                }}>
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.getConstants().isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.blackLight,
                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={"تاریخ ارجاع :"}
                                                        //   text={"98/03/21"}
                                                    />
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.getConstants().isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDark,

                                                                }}
                                                                text={_item.referDateExpert}
                                                        //   text={"98/03/21"}
                                                    />
                                                </View>
                                            </View>
                                            <View
                                                style={{
                                                    width: '100%', flexDirection: "row",
                                                    marginHorizontal: moderateScale(2),
                                                    marginTop: moderateScale(6)
                                                }}>
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(14),
                                                                color: Colors.blackLight,
                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={"توضیحات :"}
                                                    //   text={"98/03/21"}
                                                />
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDark,
                                                            }}
                                                            text={_item.descriptionExpert}
                                                    //   text={"98/03/21"}
                                                />
                                            </View>
                                        </View>
                                        <View style={{width: "100%", alignItems: "center"}}>
                                            <View style={{
                                                borderRadius: moderateScale(8),
                                                borderColor: Colors.blackLight,
                                                borderWidth: moderateScale(1),
                                                width: "98%",
                                                alignSelf: "center",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(10),
                                                marginVertical: moderateScale(10),
                                                // height: moderateScale(350)
                                            }}>
                                                <View
                                                    style={{
                                                        // flexDirection: "row",
                                                        // flexWrap: 'wrap',
                                                        flex: 1,
                                                        //  flexGrow: 1,
                                                        // lineHeight: moderateScale(10),
                                                        // justifyContent: "space-between",
                                                    }}>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"عنوان :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.subject}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"توضیحات :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.description}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"تاریخ ثبت :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.createdtime}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"آدرس :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.address}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"ثبت کننده :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.contact}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"شماره موبایل :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.mobile}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"وضعیت :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.getConstants().isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={_item.status}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            flexWrap: 'wrap',
                                                            flex: 1,
                                                            flexGrow: 1,
                                                            // lineHeight: moderateScale(10),
                                                            justifyContent: "space-between",
                                                        }}>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                marginHorizontal: moderateScale(2),
                                                                marginVertical: moderateScale(4)
                                                            }}>
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.blackLight,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={"چند روز کاری :"}
                                                                //   text={"98/03/21"}
                                                            />
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(13),
                                                                            color: Colors.colorDark,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={_item.CurrentPlanDate}
                                                                //   text={"98/03/21"}
                                                            />
                                                        </View>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                marginHorizontal: moderateScale(2),
                                                                marginVertical: moderateScale(4)
                                                            }}>
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.blackLight,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={"برآورد بودجه :"}
                                                                //   text={"98/03/21"}
                                                            />
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(13),
                                                                            color: Colors.colorDark,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={_item.CurrentPlanCost}
                                                                //   text={"98/03/21"}
                                                            />
                                                        </View>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                marginHorizontal: moderateScale(2),
                                                                marginVertical: moderateScale(4)
                                                            }}>
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.blackLight,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={"چند روز کار آتی :"}
                                                                //   text={"98/03/21"}
                                                            />
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(13),
                                                                            color: Colors.colorDark,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={_item.NextPlanDate}
                                                                //   text={"98/03/21"}
                                                            />
                                                        </View>

                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                marginHorizontal: moderateScale(2),
                                                                marginVertical: moderateScale(4)
                                                            }}>
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.blackLight,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={"برآورد بودجه آتی :"}
                                                                //   text={"98/03/21"}
                                                            />
                                                            <HMTextView type={"bold"}
                                                                        noFont={!I18nManager.getConstants().isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(13),
                                                                            color: Colors.colorDark,
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        text={_item.NextPlanCost}
                                                                //   text={"98/03/21"}
                                                            />
                                                        </View>
                                                    </View>
                                                    {this.renderFiles(_item.files)}

                                                </View>
                                            </View>

                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    backgroundColor: Colors.white,
                                                    paddingHorizontal: moderateScale(6)
                                                }}>
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDarkText,
                                                            }}
                                                            text={"مشخصات درخواست محله ما"}
                                                    //   text={"98/03/21"}
                                                />
                                            </View>

                                        </View>
                                        <View style={{width: "100%", alignItems: "center"}}>
                                            <View style={{
                                                borderRadius: moderateScale(8),
                                                borderColor: Colors.blackLight,
                                                borderWidth: moderateScale(1),
                                                width: "98%",
                                                alignSelf: "center",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(10),
                                                marginVertical: moderateScale(10),
                                                //  height: moderateScale(300)
                                            }}>
                                                <HMTextInput
                                                    _ref={(ref) => this.TextInputresultExpertRef = ref}
                                                    // style={{height: moderateScale(40),
                                                    //     borderColor: 'gray',
                                                    //     borderWidth: moderateScale(1),
                                                    //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                    //
                                                    // }}
                                                    //  title={ "نام کاربری"}
                                                    placeholder={"... نتیجه کارشناسی "}
                                                    // title={'constant.phoneNumber'}
                                                    // placeholder={'constant.PH_phoneNumber'}
                                                    // lang
                                                    styleTitle={{color: Colors.blackLight}}
                                                    onChangeText={text => this.onChangeText("TextInputresultExpert", text)}
                                                    onSubmitEditing={() => {
                                                        //  this.checkMobile(this.state.mobile)
                                                    }}
                                                    // onPressClear={() => this.onChangeText("value", null)}
                                                    onPressClear={() => {
                                                        this.onChangeText("TextInputresultExpert", null)
                                                        this.TextInputresultExpertRef.clear()
                                                    }}
                                                    value={this.state.TextInputresultExpert}
                                                    //keyboardType="numeric"
                                                    styleRoot={{
                                                        borderRadius: moderateScale(8),
                                                        borderColor: Colors.blackLight,
                                                        borderWidth: moderateScale(1),
                                                    }}
                                                />
                                                <HMFilesTest
                                                    stateParent={this.state}
                                                    _setStateData={this._setStateData}
                                                    // _setStateDataParent={container.props._setStateData}
                                                    SizeBox={3}
                                                    styleRoot2={{
                                                        flexDirection: 'row',
                                                        flexWrap: 'wrap',
                                                        width: "100%",

                                                        // flexGrow: 1,
                                                        //  backgroundColor: "#ee04d0",
                                                        alignItems: "flex-start"

                                                    }}
                                                    //clearState={this.clearState}

                                                />
                                            </View>

                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    backgroundColor: Colors.white,
                                                    paddingHorizontal: moderateScale(6)
                                                }}>
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.getConstants().isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDarkText,
                                                            }}
                                                            text={"نتیجه کارشناسی"}
                                                    //   text={"98/03/21"}
                                                />

                                            </View>

                                        </View>
                                        <View
                                            style={{
                                                width: "98%",
                                                flexDirection: "row",
                                                alignSelf: "center",
                                                alignItems: "center"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.getConstants().isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"آیا نیاز به جلسه با مسئولین محله دارد؟"}
                                                //   text={"98/03/21"}
                                            />
                                            <HMListCheckBox
                                                data={{
                                                    list: [
                                                        {id: 1, name: "بله"},
                                                        {id: 2, name: "خیر"},

                                                    ],
                                                    indexSelect: this.state['indexSelectCheckBoxType'],
                                                    name: 'Type',

                                                }}
                                                onPress={
                                                    this.onPressSelectCheckBox
                                                }

                                            />


                                        </View>
                                        {
                                            this.state['indexSelectCheckBoxType'] == 1 ?
                                                <HMTextInput
                                                    _ref={(ref) => this.TextInputResultToMeetingRef = ref}
                                                    // style={{height: moderateScale(40),
                                                    //     borderColor: 'gray',
                                                    //     borderWidth: moderateScale(1),
                                                    //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                    //
                                                    // }}
                                                    //  title={ "نام کاربری"}
                                                    placeholder={"... نتیجه جلسه "}
                                                    // title={'constant.phoneNumber'}
                                                    // placeholder={'constant.PH_phoneNumber'}
                                                    // lang
                                                    styleTitle={{color: Colors.blackLight}}
                                                    onChangeText={text => this.onChangeText("TextInputResultToMeeting", text)}
                                                    onSubmitEditing={() => {
                                                        //  this.checkMobile(this.state.mobile)
                                                    }}
                                                    // onPressClear={() => this.onChangeText("value", null)}
                                                    onPressClear={() => {
                                                        this.onChangeText("TextInputResultToMeeting", null)
                                                        this.TextInputResultToMeetingRef.clear()
                                                    }}
                                                    value={this.state.TextInputResultToMeeting}
                                                    //  keyboardType="numeric"
                                                    styleRoot={{
                                                        width: "98%",
                                                        alignSelf: "center",
                                                        borderRadius: moderateScale(8),
                                                        borderColor: Colors.blackLight,
                                                        backgroundColor: Colors.white,
                                                        borderWidth: moderateScale(1),

                                                    }}
                                                />
                                                :
                                                null
                                        }
                                        <View
                                            style={{
                                                width: '100%',
                                                height: moderateScale(42),
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: moderateScale(10),
                                                marginBottom: moderateScale(3),
                                            }}
                                        >
                                            <TouchableOpacity
                                                onPress={() => {

                                                    this.setDataSendAnswer();
                                                }}
                                                style={{
                                                    flex: .48,
                                                    height: moderateScale(42),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderRadius: moderateScale(6)

                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={"ارسال پاسخ کارشناسی"} type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(13),
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                            <View style={{width: moderateScale(8)}}/>
                                            <TouchableOpacity

                                                onPress={() => {
                                                    NavigationService.Pop();
                                                }}
                                                style={{
                                                    flex: .48,
                                                    height: moderateScale(42),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6)
                                                }}>
                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={"بازگشت به کارتابل"} type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(13),
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(4),
                                                        color: Colors.blackLight
                                                    }}/>
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                            }


                        </ScrollView>

                        {
                            this.props.isLoadingSet ?
                                <DialogLoadingCustomize/>
                                : null
                        }
                        {
                            this.state.visibleModal === 'selectSlider' || this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                <View
                                    style={{
                                        position: 'absolute',
                                        flex: 1,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.7)',
                                        zIndex: 9900
                                    }}>
                                    <View
                                        style={{
                                            height: "100%",
                                            width: '100%',
                                            // padding: moderateScale(6),
                                            backgroundColor: Colors.black,
                                            position: 'relative'
                                        }}>
                                        {
                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                }}

                                            >
                                                {/*<FlatList*/}
                                                {/*ref={(ref) => { this.flatListRef = ref }}*/}
                                                {/*data={[1,2,3,4,5]}*/}
                                                {/*extraData={this.state}*/}
                                                {/*//  onScroll={(e) => this.pauseAll(e)}*/}
                                                {/*showsHorizontalScrollIndicator={false}*/}
                                                {/*// scrollEnabled={this.state.isPortrait}*/}
                                                {/*horizontal={true}*/}
                                                {/*renderAheadOffset={0}*/}
                                                {/*initialNumToRender={5}*/}
                                                {/*windowSize={5}*/}
                                                {/*removeClippedSubviews={true}*/}
                                                {/*pagingEnabled={true}*/}
                                                {/*keyExtractor={(item, id) => id.toString()}*/}
                                                {/*renderItem={(item, index) => (this.renderFlatlist(item, index))}*/}
                                                {/*/>*/}
                                                <HMSwiper
                                                    list={this.state.sliderList}
                                                    renderItem={() =>
                                                        this.state.sliderList.map((item, index) => {
                                                            let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;

                                                            return <View
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%'
                                                                }}
                                                            >

                                                                {
                                                                    this.state.visibleModal === 'selectSlider' ?
                                                                        <Image
                                                                            resizeMode={"contain"}
                                                                            style={{
                                                                                flex: 1,
                                                                            }}
                                                                            // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                                                            source={{uri: item.file}}
                                                                        />
                                                                        :
                                                                        null
                                                                }
                                                                {/*{*/}
                                                                {/*this.state.visibleModal === 'selectVideo11' ?*/}
                                                                {/*<Video*/}
                                                                {/*style={{*/}
                                                                {/*flex: 1,*/}
                                                                {/*resizeMode: 'contain'*/}
                                                                {/*}}*/}
                                                                {/*autoPlay={false}*/}
                                                                {/*// paused={this.state["paused" + item.index]}*/}
                                                                {/*// ref={(ref) => this.video = {...this.video, [`REF-FLATLIST${index}`]: ref}}*/}
                                                                {/*ref={(ref) => {*/}
                                                                {/*//  ...this.video$, [`REF-FLATLIST${item.key}`]: ref*/}
                                                                {/*// this[`video${index}`]=ref*/}
                                                                {/*this["video" + item.index] = ref*/}
                                                                {/*}}*/}

                                                                {/*// autoPlay*/}
                                                                {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
                                                                {/*//   url={this.state.pathVideo ? this.state.pathVideo : null}*/}
                                                                {/*// url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
                                                                {/*//   url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
                                                                {/*url={item.file}*/}
                                                                {/*title={title}*/}
                                                                {/*// logo={logo}*/}
                                                                {/*//    placeholder={placeholder}*/}
                                                                {/*//  onMorePress={() => this.onMorePress()}*/}
                                                                {/*onFullScreen={status => {*/}
                                                                {/*// this["video" + item.index].pause()*/}
                                                                {/*this.onFullScreen(status)*/}
                                                                {/*}*/}
                                                                {/*}*/}
                                                                {/*//   fullScreenOnly*/}
                                                                {/*theme={theme}*/}
                                                                {/*/>*/}

                                                                {/*:*/}
                                                                {/*null*/}
                                                                {/*}*/}
                                                                {
                                                                    this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                                                        <HMVideo
                                                                            title={title}
                                                                            navigation={this.props.navigation}
                                                                            item={item} index={item.index}
                                                                            indexSelect={this.state.slider1ActiveSlide}
                                                                            //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                                                        />

                                                                        :
                                                                        null
                                                                }
                                                                {/*{*/}
                                                                {/*this.state.visibleModal === 'selectaudio' ?*/}
                                                                {/*<Video*/}
                                                                {/*style={{flex: 1, resizeMode: 'contain'}}*/}
                                                                {/*autoPlay={false}*/}
                                                                {/*ref={(ref) => {*/}
                                                                {/*this.video = ref*/}
                                                                {/*}}*/}
                                                                {/*// autoPlay*/}
                                                                {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
                                                                {/*url={item.file}*/}
                                                                {/*title={title}*/}
                                                                {/*// logo={logo}*/}
                                                                {/*//  placeholder={placeholder}*/}
                                                                {/*//  onMorePress={() => this.onMorePress()}*/}
                                                                {/*onFullScreen={status => this.onFullScreen(status)}*/}
                                                                {/*//   fullScreenOnly*/}
                                                                {/*theme={theme}*/}
                                                                {/*/>*/}
                                                                {/*:*/}
                                                                {/*null*/}
                                                                {/*}*/}

                                                            </View>

                                                        })
                                                    }
                                                />


                                                {/*     <Carousel page

                                                          ref={c => this._slider1Ref = c}
                                                          data={this.state.sliderList}
                                                    //    data={[1, 2, 3, 4, 5].}
                                                    //    data={this.state.entries}
                                                          renderItem={(item, index) => this.renderCarousel(item, index)


                                                          }
                                                    // inactiveSlideScale={.99}
                                                    // sliderWidth={sliderWidth}
                                                    // itemWidth={itemWidth}

                                                          inactiveSlideScale={1}
                                                    // sliderWidth={sliderWidth}
                                                    // itemWidth={itemWidth}

                                                          sliderWidth={Dimensions.get('window').width}
                                                          itemWidth={Dimensions.get('window').width}
                                                          hasParallaxImages={true}
                                                          firstItem={0}

                                                          inactiveSlideOpacity={0.7}
                                                    // inactiveSlideShift={20}
                                                          containerCustomStyle={styles_Carousel.slider}
                                                          contentContainerCustomStyle={styles_Carousel.sliderContentContainer}
                                                    // loop={true}
                                                    //loopClonesPerSide={1}
                                                    //    autoplay={true}
                                                    //   autoplayDelay={1000}
                                                    //   autoplayInterval={6000}
                                                          onSnapToItem={(index, item) => {


                                                              let p = "paused" + slider1ActiveSlide
                                                              this.setState({
                                                                  [p]: true,
                                                                  slider1ActiveSlide: index
                                                              }, () => {
                                                              })
                                                          }
                                                          }
                                                          removeClippedSubviews={false}
                                                />*/}
                                            </View>
                                        }
                                        {/*     <View
                                            style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: typeExport._WIDTH,
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Pagination
                                                //  data={[1, 2, 3, 4, 5]}
                                                dotsLength={this.state.sliderList.length}
                                                activeDotIndex={slider1ActiveSlide}
                                                containerStyle={styles.paginationContainer}
                                                //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                dotColor={Colors.colorSecondPrimary}
                                                dotStyle={styles.paginationDot}
                                                inactiveDotColor={Colors.white}
                                                inactiveDotOpacity={0.4}
                                                inactiveDotScale={0.6}
                                                carouselRef={this._slider1Ref}
                                                tappableDots={!!this._slider1Ref}
                                            />
                                        </View>*/}
                                    </View>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this.hiddenModal()
                                        }}

                                        style={{
                                            width: moderateScale(32),
                                            height: moderateScale(32),
                                            // backgroundColor: '#ee005b',
                                            position: 'absolute',
                                            borderRadius: moderateScale(16),
                                            margin: moderateScale(4),
                                            top: 0,
                                            left: 0,
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}>
                                        <HMIcon name={"ios-close-circle-outline"} style={{
                                            textAlign: 'center',
                                            //alignSelf: 'flex-end',
                                            color: Colors.white,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(22)
                                        }}/>
                                    </TouchableOpacity>
                                </View>
                                :
                                null
                        }
                        <HMModal
                            isVisible={this.state.visibleModal === 'selectaudio'}
                            backdropColor={Colors.gray}
                            backdropOpacity={0.8}
                            animationIn="zoomInDown"
                            animationOut="zoomOutUp"
                            animationInTiming={600}
                            animationOutTiming={600}
                            backdropTransitionInTiming={600}
                            backdropTransitionOutTiming={600}
                            //style={{height: '60%'}}
                            onBackdropPress={() => this.hiddenModal()}
                            onBackButtonPress={() => this.hiddenModal()}
                        >

                            <View style={{
                                height: "50%",
                                //      padding: moderateScale(6),
                                backgroundColor: Colors.white
                            }}>
                                <View
                                    style={{
                                        flex: 1,
                                        backgroundColor: "#2b608a",
                                    }}>

                                    <View style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flex: 1,
                                    }}>
                                        <View style={{
                                            flex: .4, alignItems: 'center',
                                            justifyContent: 'flex-end',
                                        }}>
                                            {/*<Text*/}
                                            {/*style={styles.progressText}>{Tools.getAudioTimeString(this.state.currentTime)}</Text>*/}
                                        </View>
                                        <View style={{flex: .6, alignItems: 'center'}}>
                                            <TouchableOpacity
                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    marginTop: moderateScale(15),
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(24),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',

                                                }}
                                                onPress={() => {
                                                    this.switchOnPress(checkAudio)
                                                }}
                                            >
                                                <Image
                                                    source={this.switchIcon(this.state.playState)}
                                                    style={{
                                                        width: moderateScale(24),
                                                        height: moderateScale(24),
                                                        tintColor: Colors.colorDark
                                                    }}/>
                                                {/*<Text style={{position:'absolute', alignSelf:'center', marginTop:1, color:'white', fontSize:12}}>15</Text>*/}
                                            </TouchableOpacity>

                                            <View style={{
                                                width: '100%',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Text
                                                    style={{
                                                        paddingTop: moderateScale(25),
                                                        fontSize: moderateScale(25),
                                                        color: "#fff"
                                                    }}>{Tools.getAudioTimeString(this.state.playSeconds)}</Text>


                                            </View>


                                        </View>

                                    </View>


                                    <TouchableOpacity
                                        style={{

                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(48),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',

                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            marginTop: Platform.OS === 'ios' ? moderateScale(16) : 0
                                            // bottom:0,
                                        }}

                                        onPress={
                                            () => {
                                                this.setState(
                                                    {
                                                        // ShowAudio:f,
                                                        visibleModal: '',

                                                    }
                                                )
                                            }

                                        }>
                                        <View style={{
                                            //  flexDirection:Rtl ? 'row-reverse': 'row',
                                            flexDirection: 'row',
                                            alignItems: "flex-end",
                                            //marginHorizontal: moderateScale(4)
                                        }}>
                                            <HMIcon name={
                                                //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                                I18nManager.getConstants().isRTL ? "ios-arrow-back" : 'ios-arrow-forward'
                                                // 'ios-arrow-back'

                                            }
                                                    style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                            {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                            {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                        </View>
                                    </TouchableOpacity>

                                </View>

                            </View>
                        </HMModal>
                        {
                            // this.state.visibleModal === 'selectVideo' ?
                            //     <View
                            //         style={{
                            //             position: 'absolute',
                            //             flex: 1,
                            //             alignContent: 'center',
                            //             alignItems: 'center',
                            //             justifyContent: 'center',
                            //             marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                            //             top: 0,
                            //             bottom: 0,
                            //             right: 0,
                            //             left: 0,
                            //             backgroundColor: 'rgba(0,0,0,0.7)',
                            //             zIndex: 9900
                            //         }}>
                            //         <View
                            //             style={{
                            //                 height: "100%",
                            //                 width: '100%',
                            //                 // padding: moderateScale(6),
                            //                 backgroundColor: Colors.black
                            //             }}>
                            //             <HMVideo
                            //                 title={title}
                            //                 navigation={this.props.navigation}
                            //                 indexSelect={this.state.slider1ActiveSlide}
                            //                 offline={!files}
                            //                 video={video}
                            //                 path={this.state.pathVideo ? this.state.pathVideo : null}
                            //                 //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                            //             />
                            //             {/* {
                            //                 files ?
                            //                     <Video
                            //                         style={{flex: 1, resizeMode: 'contain'}}
                            //                         autoPlay={false}
                            //                         ref={(ref) => {
                            //                             this.video = ref
                            //                         }}
                            //                         // autoPlay
                            //                         //  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}
                            //                         //     url={checkVideo ? checkVideo : null}
                            //                         url={this.state.pathVideo ? this.state.pathVideo : null}
                            //
                            //                         title={title}
                            //                         // logo={logo}
                            //                         placeholder={placeholder}
                            //                         //  onMorePress={() => this.onMorePress()}
                            //                         onFullScreen={status => this.onFullScreen(status)}
                            //                         //   fullScreenOnly
                            //                         theme={theme}
                            //                     />
                            //                     :
                            //                     <VideoPlayer
                            //                         ref={ref => this.videoPlayerRef = ref}
                            //                         //  startTime={0}  // seconds
                            //                         //  endTime={60}   // seconds
                            //                         //    play={true}     // default false
                            //                         //  replay={true}   // should player play video again if it's ended
                            //                         rotate={true}   // use this prop to rotate video if it captured in landscape mode iOS only
                            //                         source={video}
                            //                         //   playerWidth={300} // iOS only
                            //                         //  playerHeight={500} // iOS only
                            //                         style={{
                            //                             //backgroundColor: 'black',
                            //                             flex: 1,
                            //                         }}
                            //                         resizeMode={VideoPlayer.Constants.resizeMode.CONTAIN}
                            //                         onChange={({nativeEvent}) => {
                            //                         }} // get Current time on every second
                            //                     />
                            //             }*/}
                            //
                            //
                            //         </View>
                            //         <TouchableOpacity
                            //             onPress={() => {
                            //                 this.hiddenModal()
                            //             }}
                            //
                            //             style={{
                            //                 width: moderateScale(32),
                            //                 height: moderateScale(32),
                            //                 // backgroundColor: '#ee005b',
                            //                 position: 'absolute',
                            //                 borderRadius: moderateScale(16),
                            //                 margin: moderateScale(4),
                            //                 top: 0,
                            //                 left: 0,
                            //                 alignItems: 'center',
                            //                 justifyContent: 'center',
                            //
                            //             }}>
                            //             <HMIcon name={"ios-close-circle-outline"} style={{
                            //                 textAlign: 'center',
                            //                 //alignSelf: 'flex-end',
                            //                 color: Colors.white,
                            //                 // width: moderateScale(32),
                            //                 // height: moderateScale(32),
                            //                 fontSize: moderateScale(22)
                            //             }}/>
                            //         </TouchableOpacity>
                            //     </View>
                            //     : null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    renderCarousel(item, index) {


        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;

        return <View
            style={{
                width: '100%',
                height: '100%'
            }}
        >

            {
                this.state.visibleModal === 'selectSlider' ?
                    <Image
                        resizeMode={"contain"}
                        style={{
                            flex: 1,
                        }}
                        // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                        source={{uri: item.item.file}}
                    />
                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectVideo11' ?*/}
            {/*<Video*/}
            {/*style={{*/}
            {/*flex: 1,*/}
            {/*resizeMode: 'contain'*/}
            {/*}}*/}
            {/*autoPlay={false}*/}
            {/*// paused={this.state["paused" + item.index]}*/}
            {/*// ref={(ref) => this.video = {...this.video, [`REF-FLATLIST${index}`]: ref}}*/}
            {/*ref={(ref) => {*/}
            {/*//  ...this.video$, [`REF-FLATLIST${item.key}`]: ref*/}
            {/*// this[`video${index}`]=ref*/}
            {/*this["video" + item.index] = ref*/}
            {/*}}*/}

            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*//   url={this.state.pathVideo ? this.state.pathVideo : null}*/}
            {/*// url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*//   url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*url={item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//    placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => {*/}
            {/*// this["video" + item.index].pause()*/}
            {/*this.onFullScreen(status)*/}
            {/*}*/}
            {/*}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}

            {/*:*/}
            {/*null*/}
            {/*}*/}
            {
                this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                    <HMVideo
                        title={title}
                        navigation={this.props.navigation} item={item} index={item.index}
                        indexSelect={this.state.slider1ActiveSlide}
                        //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                    />

                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectaudio' ?*/}
            {/*<Video*/}
            {/*style={{flex: 1, resizeMode: 'contain'}}*/}
            {/*autoPlay={false}*/}
            {/*ref={(ref) => {*/}
            {/*this.video = ref*/}
            {/*}}*/}
            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*url={item.item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//  placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => this.onFullScreen(status)}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}
            {/*:*/}
            {/*null*/}
            {/*}*/}

        </View>
    }

    renderFiles(files) {
        return <View
            style={{
                //position:'absolute',
                flexDirection: "row",
                flexWrap: 'wrap',
                flex: 1,

                flexGrow: 1,
                //  alignItems: 'center', justifyContent: 'center',
                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                //  backgroundColor: "#876a79",
            }}>


            {
                files && files.length > 0 ?
                    (files).map((item, key) => {
                        //let f = String(files[key].type);
                        let f = String(item.type);
                        if (f.search('audio/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        //   pathVideo: checkAudio,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            type={"MaterialCommunityIcons"}
                                            name={"account-tie-voice"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else if (f.search('image/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectSlider",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >
                                <HMImageView
                                    resizeMode={'cover'}
                                    uriComplete={item.file}
                                    _backgroundColorLoading={Colors.black}
                                    styleImage={{
                                        //  resizeMode: 'cover',
                                        width: "100%",
                                        height: "100%",
                                        //   backgroundColor: "#ee7e0c",
                                        //  borderTopRightRadius:moderateScale(8),
                                        //  borderTopEndRadius: moderateScale(12),
                                        //  borderTopStartRadius: moderateScale(8),
                                    }}
                                    //  onLoad={this._onLoad}
                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                />
                            </TouchableOpacity>
                        else if (f.search('video/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        // pathVideo: checkVideo,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"play"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else {


                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectListOthers",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"attach"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>
                        }


                    })
                    :
                    null
            }

        </View>
    }

    _setStateData(object) {
        container.setState(object);
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
                ['DescriptionSelectCheckBox' + name]: (item.description)
            },
            () => {
            })
    }

    onChangeText(name, text) {
        this.setState({[name]: text});
    }
}

const styles = StyleSheet.create({

    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

